function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M211.265,389.248l-60.331,60.331c-25.012,25.012-65.517,25.012-90.508,0.005c-24.996-24.996-24.996-65.505-0.005-90.496 l120.683-120.683c24.991-24.992,65.5-24.992,90.491,0c8.331,8.331,21.839,8.331,30.17,0c8.331-8.331,8.331-21.839,0-30.17 c-41.654-41.654-109.177-41.654-150.831,0L30.252,328.918c-41.654,41.654-41.654,109.177,0,150.831 c41.649,41.676,109.177,41.676,150.853,0l60.331-60.331c8.331-8.331,8.331-21.839,0-30.17S219.596,380.917,211.265,389.248z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M479.756,181.08c41.654-41.654,41.654-109.177,0-150.831c-41.653-41.653-109.173-41.653-150.848-0.005l-72.389,72.389 c-8.331,8.331-8.331,21.839,0,30.17s21.839,8.331,30.17,0l72.384-72.384c25.008-24.992,65.521-24.992,90.513,0 c24.991,24.991,24.991,65.5,0,90.491L316.85,283.646c-24.992,24.992-65.5,24.992-90.491,0c-8.331-8.331-21.839-8.331-30.17,0 s-8.331,21.839,0,30.17c41.654,41.654,109.177,41.654,150.831,0L479.756,181.08z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M398.099,367.926c-8.331-8.331-21.839-8.331-30.17,0c-8.331,8.331-8.331,21.839,0,30.17l63.979,63.979 c8.331,8.331,21.839,8.331,30.17,0c8.331-8.331,8.331-21.839,0-30.17L398.099,367.926z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.946,142.113c8.331,8.331,21.839,8.331,30.17,0s8.331-21.839,0-30.17L78.073,47.9c-8.331-8.331-21.839-8.331-30.17,0 c-8.331,8.331-8.331,21.839,0,30.17L111.946,142.113z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M489.67,319h-64c-11.782,0-21.333,9.551-21.333,21.333c0,11.782,9.551,21.333,21.333,21.333h64 c11.782,0,21.333-9.551,21.333-21.333C511.003,328.551,501.452,319,489.67,319z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.67,105.667c11.782,0,21.333-9.551,21.333-21.333v-64C191.003,8.551,181.452-1,169.67-1 c-11.782,0-21.333,9.551-21.333,21.333v64C148.336,96.115,157.888,105.667,169.67,105.667z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.336,191h64c11.782,0,21.333-9.551,21.333-21.333c0-11.782-9.551-21.333-21.333-21.333h-64 c-11.782,0-21.333,9.551-21.333,21.333C-0.997,181.449,8.554,191,20.336,191z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M340.336,404.333c-11.782,0-21.333,9.551-21.333,21.333v64c0,11.782,9.551,21.333,21.333,21.333 c11.782,0,21.333-9.551,21.333-21.333v-64C361.67,413.885,352.118,404.333,340.336,404.333z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgBrokenLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.006 512.006",
    style: {
      enableBackground: "new 0 0 512.006 512.006"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenLink);
export default __webpack_public_path__ + "static/media/broken-link.124f87b6.svg";
export { ForwardRef as ReactComponent };